/* ZIIV custom sections — reveal-on-scroll.
   Content is visible by default; hiding is gated on the .zv-js class added
   here. Reveal uses a synchronous scroll sweep plus a timer fallback —
   no rAF or IntersectionObserver, since neither runs when the renderer
   treats the document as hidden (embedded previews, background tabs),
   which would leave sections invisible. */
(function () {
  if (window.__zvRevealInit) return;
  window.__zvRevealInit = true;

  // Hidden documents (background tabs, embedded previews) don't run rAF or
  // paint transitions — leave content fully visible there instead of animating.
  if (document.visibilityState === 'hidden') return;
  document.documentElement.classList.add('zv-js');

  var els = [];

  function sweep() {
    els = els.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight - 40 && r.bottom > 0) {
        el.classList.add('zv-in');
        return false;
      }
      return true;
    });
  }

  function collect() {
    var found = document.querySelectorAll('.zv-reveal:not(.zv-in)');
    for (var i = 0; i < found.length; i++) {
      if (els.indexOf(found[i]) === -1) els.push(found[i]);
    }
    sweep();
  }

  window.addEventListener('scroll', sweep, { passive: true });
  window.addEventListener('resize', sweep);
  setInterval(function () { if (els.length) sweep(); }, 300);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
  // Re-collect when the Shopify theme editor re-renders a section
  document.addEventListener('shopify:section:load', collect);
})();
